import React from "react";
import { Box, LinearProgress, Typography } from "@mui/material";
import WebProfitSpinner from "./WebProfitSpinner";

export default function WebProfitLoadingScreen({
  title = "Cargando WebProfit",
  description = "Preparando tu espacio de trabajo…",
  compact = false,
}) {
  return (
    <Box
      role="status"
      aria-live="polite"
      aria-busy="true"
      sx={{
        minHeight: compact ? 280 : "100vh",
        width: "100%",
        display: "grid",
        placeItems: "center",
        px: 3,
        bgcolor: "var(--wp-panel-bg, #fff)",
      }}
    >
      <Box sx={{ width: "min(360px, 86vw)", textAlign: "center" }}>
        <WebProfitSpinner size={compact ? 54 : 68} label={title || "Cargando WebProfit"} sx={{ mx: "auto" }} />
        {title ? (
          <Typography sx={{ mt: 2, fontWeight: 900, color: "var(--wp-panel-text-primary, #19242f)", fontSize: compact ? 16 : 18 }}>
            {title}
          </Typography>
        ) : null}
        {description ? (
          <Typography sx={{ mt: 0.6, color: "var(--wp-panel-text-secondary, #65717d)", fontSize: 13.5 }}>
            {description}
          </Typography>
        ) : null}
        <LinearProgress
          sx={{
            mt: 2.25,
            height: 5,
            borderRadius: 999,
            bgcolor: "rgba(243,90,58,.12)",
            "& .MuiLinearProgress-bar": { borderRadius: 999, bgcolor: "#f35a3a" },
          }}
        />
      </Box>
    </Box>
  );
}
